import React from 'react';
import './TermsOfService.css';

function TermsOfService() {
  const handleBackToHome = () => {
    window.location.hash = '';
    window.scrollTo(0, 0);
  };

  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <div className="nav-container">
          <div className="logo">
            <span className="logo-text" onClick={handleBackToHome} style={{ cursor: 'pointer' }}>PlayTiny</span>
          </div>
          <button className="back-button" onClick={handleBackToHome}>← Back to Home</button>
        </div>
      </nav>

      <div className="legal-content">
        <div className="container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: April 4, 2026</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using PlayTiny's mobile applications, you accept and agree to be bound by the
              terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2>2. Use License</h2>
            <p>Permission is granted to temporarily download one copy of our applications for personal, non-commercial transitory
              viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
            <ul>
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained in our applications</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            </ul>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>When you create an account with us, you must provide information that is accurate, complete, and current
              at all times. You are responsible for safeguarding the password and for all activities that occur under your account.</p>
          </section>

          <section>
            <h2>4. In-App Purchases</h2>
            <p>
              Our applications may offer in-app purchases. All purchases are final and non-refundable unless required by law.
              Prices are subject to change without notice. Virtual items and currency have no monetary value and cannot
              be exchanged for real money.
            </p>
          </section>

          <section>
            <h2>5. Advertising</h2>
            <p>
              Our applications may contain advertisements from third-party advertising networks, such as Google AdMob. By using our applications, you agree to receive such advertising. We are not responsible for the content, privacy practices, or accuracy of any third-party advertisements or the websites/services they link to. Your interactions with advertisers found within our applications are solely between you and such advertisers.
            </p>
          </section>

          <section>
            <h2>6. Prohibited Uses</h2>
            <p>You may not use our applications:</p>
            <ul>
              <li>In any way that violates any applicable national or international law or regulation</li>
              <li>To transmit, or procure the sending of, any advertising or promotional material</li>
              <li>To impersonate or attempt to impersonate the company, a company employee, another user, or any other person or entity</li>
              <li>In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent, or harmful</li>
              <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the applications</li>
            </ul>
          </section>

          <section>
            <h2>7. Intellectual Property Rights</h2>
            <p>
              The applications and their original content, features, and functionality are and will remain the exclusive property
              of PlayTiny and its licensors. The applications are protected by copyright, trademark, and other laws. Our trademarks
              and trade dress may not be used in connection with any product or service without our prior written consent.
            </p>
          </section>

          <section>
            <h2>8. User Content</h2>
            <p>
              Our applications may allow you to post, link, store, share and otherwise make available certain information, text,
              graphics, or other material. You are responsible for the content that you post on or through the applications,
              including its legality, reliability, and appropriateness.
            </p>
          </section>

          <section>
            <h2>9. Disclaimer</h2>
            <p>
              The information on our applications is provided on an "as is" basis. To the fullest extent permitted by law, PlayTiny
              excludes all representations, warranties, conditions and terms relating to our applications and the use of our applications.
            </p>
          </section>

          <section>
            <h2>10. Limitation of Liability</h2>
            <p>
              In no event shall PlayTiny, nor its directors, employees, partners, agents, suppliers, or affiliates, be
              liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation,
              loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of our applications.
            </p>
          </section>

          <section>
            <h2>11. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless PlayTiny and its licensee and licensors, and their employees,
              contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses,
              liabilities, costs or debt, and expenses (including but not limited to attorney's fees).
            </p>
          </section>

          <section>
            <h2>12. Termination</h2>
            <p>
              We may terminate or suspend your account and bar access to the applications immediately, without prior notice or
              liability, under our sole discretion, for any reason whatsoever and without limitation, including but not
              limited to a breach of the Terms.
            </p>
          </section>

          <section>
            <h2>13. Governing Law</h2>
            <p>
              These Terms shall be interpreted and governed by the laws of India, without regard to its conflict of law
              provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of
              those rights.
            </p>
          </section>

          <section>
            <h2>14. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision
              is material, we will provide at least 30 days notice prior to any new terms taking effect.
            </p>
          </section>

          <section>
            <h2>15. Contact Information</h2>
            <p>If you have any questions about these Terms of Service, please contact us:</p>
            <ul>
              <li>Email: restofthings8@gmail.com</li>
              <li>Location: Hayathnagar, Telangana, India</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;

